import { Injectable } from "@angular/core";
import { BasketService } from "src/app/services/basket.service";

import { Basket } from "../models/Enums";
import { CompanyService } from "./company.service";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class PoBasketService extends BasketService {
  constructor(companyService: CompanyService, storageService: StorageService) {
    super(Basket.PurchaseOrder, companyService, [], storageService);
  }
}
